import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { styles } from './Grid.scss';

const cx = classNames.bind(styles);

export const Grid = ({
  gutter,
  rowGutter,
  align,
  justify,
  children,
  className,
  ...props
}) => {
  const classes = cx(
    'l-grid',
    {
      [`l-grid--gutter-${gutter}`]: gutter,
      [`l-grid--row-gutter-${rowGutter}`]: rowGutter,
      [`l-grid--align-${align}`]: align,
      [`l-grid--justify-${justify}`]: justify,
    },
    className,
  );

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

Grid.propTypes = {
  /**
   * Spacing between the columns of the grid.
   */
  gutter: PropTypes.oneOf(['none', 'xsmall', 'small', 'medium', 'large']),
  /**
   * Spacing between the rows of the grid.
   */
  rowGutter: PropTypes.oneOf(['none', 'xsmall', 'small', 'medium', 'large']),
  /**
   * the alignment of the flex layout items align the main axis
   */
  align: PropTypes.oneOf(['start', 'center', 'end', 'stretch']),
  /**
   * the alignment of the flex layout items, perpenticular to the main axis
   */
  justify: PropTypes.oneOf(['start', 'center', 'end', 'around', 'between']),
  /**
   * Extend the classNames applied to the component
   */
  className: PropTypes.string,
  children: PropTypes.node,
};

Grid.defaultProps = {
  gutter: 'medium',
  rowGutter: 'none',
  align: 'start',
  justify: 'start',
  className: '',
};
